<div class="edit-user-form">
  <div class="component-loader" *ngIf="isSaving">
    <cx-spinner></cx-spinner>
  </div>

  <div class="d-flex flex-wrap align-items-center mb-3">
    <!-- Card 1: User Details -->
    <h2 class="customersearch-title mb-0">{{ 'atgUserManagement.editUser.userDetails' | cxTranslate }}</h2>

    <!-- Back Button -->
    <button class="btn back-btn p-1 font-lg-size ml-auto" (click)="goBack()" type="button" title="Back to Users">
      <i class="fas fa-level-down-alt fa-rotate-90" aria-hidden="true"></i>
    </button>
  </div>
  <div class="card">
    <div class="card-body">
      <form [formGroup]="editUserForm">

        <!-- Row 1: Status / Name / Email / Account Activated Date -->
        <div class="row mx-0">

          <!-- Account Status -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="accountStatus" class="text-muted">{{ 'atgUserManagement.editUser.accountStatus' | cxTranslate }}</label>
            <ng-select formControlName="accountStatus" [items]="accountStatusOptions" bindLabel="label" bindValue="value"
              [placeholder]="'atgUserManagement.editUser.accountStatus' | cxTranslate" [searchable]="false" [clearable]="false" labelForId="accountStatus">
            </ng-select>
          </div>

          <!-- Customer Name -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="customerName" class="text-muted">{{ 'atgUserManagement.editUser.customerName' | cxTranslate }}</label>
            <input id="customerName" type="text" class="form-control w-100" formControlName="name" [placeholder]="'atgUserManagement.editUser.customerName' | cxTranslate" />
            <span class="highlight"></span>
          </div>

          <!-- E-Mail (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2 read-only-field">
            <label for="email" class="text-muted">{{ 'atgUserManagement.editUser.email' | cxTranslate }}</label>
            <input id="email" type="text" class="form-control w-100" formControlName="email" [placeholder]="'atgUserManagement.editUser.email' | cxTranslate" />
            <span class="highlight"></span>
          </div>

          <!-- Account Activated Date (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2 read-only-field">
            <label for="accountActivatedDate" class="text-muted">{{ 'atgUserManagement.editUser.accountActivatedDate' | cxTranslate }}</label>
            <input id="accountActivatedDate" type="text" class="form-control w-100" formControlName="accountActivatedDate"
              [placeholder]="'atgUserManagement.editUser.accountActivatedDate' | cxTranslate" />
            <span class="highlight"></span>
          </div>
        </div>

        <!-- Row 2: Activated By / User Role / Date Format / Phone Number -->
        <div class="row mx-0">

          <!-- Activated By (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2 read-only-field">
            <label for="activatedBy" class="text-muted">{{ 'atgUserManagement.editUser.activatedBy' | cxTranslate }}</label>
            <input id="activatedBy" type="text" class="form-control w-100" formControlName="activatedBy" [placeholder]="'atgUserManagement.editUser.activatedBy' | cxTranslate" />
            <span class="highlight"></span>
          </div>

          <!-- User Role -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="userRole" class="text-muted">{{ 'atgUserManagement.editUser.userRole' | cxTranslate }}</label>
            <div class="select-wrapper ng-select-wrapper">
              <ng-select formControlName="userRole" [items]="userRoleOptions" bindLabel="label" bindValue="value"
                [placeholder]="'atgUserManagement.editUser.userRole' | cxTranslate" [searchable]="false" [clearable]="false" labelForId="userRole"
                [disabled]="isLoadingUserRoles" class="w-100">
              </ng-select>
            </div>
            <span class="highlight"></span>
          </div>

          <!-- Date Format -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="dateFormat" class="text-muted">{{ 'atgUserManagement.editUser.dateFormat' | cxTranslate }}</label>
            <ng-select formControlName="dateFormat" [items]="dateFormatOptions" bindLabel="label" bindValue="value"
              [placeholder]="'atgUserManagement.editUser.dateFormat' | cxTranslate" [searchable]="false" [clearable]="false" labelForId="dateFormat">
            </ng-select>
          </div>

          <!-- Phone Number -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="phoneNumber" class="text-muted">{{ 'atgUserManagement.editUser.phoneNumber' | cxTranslate }}</label>
            <input id="phoneNumber" type="text" class="form-control w-100" formControlName="phoneNumber" [placeholder]="'atgUserManagement.editUser.phoneNumber' | cxTranslate"
              knBrNumbersOnly
              maxlength="10"
              [class.border-danger]="editUserForm.get('phoneNumber')!.invalid && editUserForm.get('phoneNumber')!.touched" />
            <span class="highlight"></span>
            @if (editUserForm.get('phoneNumber')!.touched) {
            @if (editUserForm.get('phoneNumber')!.hasError('pattern')) {
            <div class="text-danger font-size-14 mt-1">{{ 'atgUserManagement.editUser.phoneNumberPattern' | cxTranslate }}</div>
            }
            @if (editUserForm.get('phoneNumber')!.hasError('minlength') && !editUserForm.get('phoneNumber')!.hasError('pattern')) {
            <div class="text-danger font-size-14 mt-1">{{ 'atgUserManagement.editUser.phoneNumberMinLength' | cxTranslate }}</div>
            }
            @if (editUserForm.get('phoneNumber')!.hasError('maxlength') && !editUserForm.get('phoneNumber')!.hasError('pattern')) {
            <div class="text-danger font-size-14 mt-1">{{ 'atgUserManagement.editUser.phoneNumberMaxLength' | cxTranslate }}</div>
            }
            }
          </div>

        </div>

        <!-- Row 3: Language / Address Line 1 / Address Line 2 / City -->
        <div class="row mx-0">

          <!-- Language -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="language" class="text-muted">{{ 'atgUserManagement.editUser.language' | cxTranslate }}</label>
            <ng-select formControlName="language" [items]="languageOptions" bindLabel="label" bindValue="value"
              [placeholder]="'atgUserManagement.editUser.selectLanguage' | cxTranslate" [searchable]="false" [clearable]="false" labelForId="language">
            </ng-select>
          </div>

          <!-- Address Line 1 -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="addressLine1" class="text-muted">{{ 'atgUserManagement.editUser.addressLine1' | cxTranslate }}</label>
            <input id="addressLine1" type="text" class="form-control w-100" formControlName="addressLine1" [placeholder]="'atgUserManagement.editUser.addressLine1' | cxTranslate" />
            <span class="highlight"></span>
          </div>

          <!-- Address Line 2 -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="addressLine2" class="text-muted">{{ 'atgUserManagement.editUser.addressLine2' | cxTranslate }}</label>
            <input id="addressLine2" type="text" class="form-control w-100" formControlName="addressLine2" [placeholder]="'atgUserManagement.editUser.addressLine2' | cxTranslate" />
            <span class="highlight"></span>
          </div>

          <!-- City -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="city" class="text-muted">{{ 'atgUserManagement.editUser.city' | cxTranslate }}</label>
            <input id="city" type="text" class="form-control w-100" formControlName="city" [placeholder]="'atgUserManagement.editUser.city' | cxTranslate" />
            <span class="highlight"></span>
          </div>

        </div>

        <!-- Row 3b: State/Province / ZIP Code/Postal Code / Country -->
        <div class="row mx-0">

          <!-- State/Province -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="state" class="text-muted">{{ 'atgUserManagement.editUser.state' | cxTranslate }}</label>
            <ng-select formControlName="state" [items]="(states$ | async) || []" bindLabel="name" bindValue="isocode"
              [placeholder]="'atgUserManagement.editUser.selectState' | cxTranslate" [loading]="isStateLoading"
              [searchable]="true" [clearable]="false" [disabled]="isStateLoading || !(states$ | async)?.length" labelForId="state">
            </ng-select>
          </div>

          <!-- ZIP Code/Postal Code -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="postalCode" class="text-muted">{{ 'atgUserManagement.editUser.postalCode' | cxTranslate }}</label>
            <input id="postalCode" type="text" class="form-control w-100" formControlName="postalCode" [placeholder]="'atgUserManagement.editUser.postalCode' | cxTranslate" />
            <span class="highlight"></span>
          </div>

          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <label for="country" class="text-muted">{{ 'atgUserManagement.editUser.country' | cxTranslate }}</label>
            <ng-select formControlName="country" [items]="(countries$ | async) || []" bindLabel="name" bindValue="isocode"
              [placeholder]="'atgUserManagement.editUser.selectCountry' | cxTranslate" [loading]="isCountryLoading" [searchable]="true" [clearable]="false" labelForId="country"
              (change)="onCountryChanged()">
            </ng-select>
          </div>
        </div>

        <!-- Row 4: User Created On / Last Login Date / Email Sent Date / Email Sent By -->
        <div class="row mx-0">

          <!-- User Created On (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <span class="text-muted d-block">{{ 'atgUserManagement.editUser.userCreatedOn' | cxTranslate }}</span>
            <p class="form-control-plaintext">{{ editUserForm.get('userCreatedOn')?.value || '—' }}</p>
          </div>

          <!-- Last Login Date (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <span class="text-muted d-block">{{ 'atgUserManagement.editUser.lastLoginDate' | cxTranslate }}</span>
            <p class="form-control-plaintext">{{ editUserForm.get('lastLoginDate')?.value || '—' }}</p>
          </div>

          <!-- E-Mail Sent Date (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <span class="text-muted d-block">{{ 'atgUserManagement.editUser.emailSentDate' | cxTranslate }}</span>
            <p class="form-control-plaintext">{{ editUserForm.get('emailSentDate')?.value || '—' }}</p>
          </div>

          <!-- E-Mail Sent By (Read Only) -->
          <div class="form-group col-12 col-sm-6 col-lg-3 mt-3 mb-3 px-2">
            <span class="text-muted d-block">{{ 'atgUserManagement.editUser.emailSentBy' | cxTranslate }}</span>
            <p class="form-control-plaintext">{{ editUserForm.get('emailSentBy')?.value || '—' }}</p>
          </div>

        </div>

        <!-- Row 5: Create Order checkbox -->
        <div class="row mx-0">
          <div class="col-12 mt-4 pt-2 mb-3 px-2">
            <div class="remember-me d-flex align-items-center">
              <div class="form-check custom-checkbox m-0">
                <input type="checkbox" class="custom-control-input" id="createOrder" formControlName="createOrder" />
                <label class="custom-control-label color-font" for="createOrder">{{ 'atgUserManagement.editUser.createOrder' | cxTranslate }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Accounts List -->
        <div class="col-12 p-0 mt-2 mb-3">
          <atg-add-edit-users-list [userRole]="editUserForm.get('userRole')?.value" [initialParentSoldToList]="parentSoldToList" (accountsPayload)="onAccountsPayloadChange($event)"></atg-add-edit-users-list>
        </div>

        <!-- Form Actions -->
        <div class="col-12 p-0 mt-3 mb-2 d-flex flex-wrap">
          <button type="button" class="btn btn-primary mr-3" (click)="onSave()" [disabled]="editUserForm.invalid || isSaving">
            {{ isSaving ? ('atgUserManagement.editUser.submitting' | cxTranslate) : ('atgUserManagement.editUser.save' | cxTranslate) }}
          </button>
          <button type="button" class="btn btn-secondary mr-3" (click)="onCancel()">
            {{ 'atgUserManagement.editUser.cancel' | cxTranslate }}
          </button>
        </div>

      </form>
    </div>
  </div>

  <!-- Card 2: Reset Password -->
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">{{ 'atgUserManagement.editUser.resetPassword' | cxTranslate }}</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="passwordForm">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="newPassword" class="form-label">{{ 'atgUserManagement.editUser.newPassword' | cxTranslate }} <span class="text-danger">*</span></label>
            <div class="position-relative">
              <input id="newPassword" [type]="showNewPassword ? 'text' : 'password'" class="form-control pe-5"
                formControlName="newPassword" [placeholder]="'atgUserManagement.editUser.enterNewPassword' | cxTranslate" />
              <span class="password-toggle-icon" tabindex="0"
                (click)="showNewPassword = !showNewPassword"
                (keydown.enter)="showNewPassword = !showNewPassword">
                <i class="bi" [ngClass]="showNewPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </span>
            </div>
            <cx-form-errors [control]="passwordForm.get('newPassword')"></cx-form-errors>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="confirmPassword" class="form-label">{{ 'atgUserManagement.editUser.confirmNewPassword' | cxTranslate }} <span class="text-danger">*</span></label>
            <div class="position-relative">
              <input id="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'" class="form-control pe-5"
                formControlName="confirmPassword" [placeholder]="'atgUserManagement.editUser.confirmNewPasswordPlaceholder' | cxTranslate" />
              <span class="password-toggle-icon" tabindex="0"
                (click)="showConfirmPassword = !showConfirmPassword"
                (keydown.enter)="showConfirmPassword = !showConfirmPassword">
                <i class="bi" [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </span>
            </div>
            <cx-form-errors [control]="passwordForm.get('confirmPassword')"></cx-form-errors>
          </div>
        </div>
        <div class="mt-2 d-flex flex-wrap">
          <button type="button" class="btn btn-primary mr-3" (click)="onResetPassword()" [disabled]="isResettingPassword">
            {{ isResettingPassword ? ('atgUserManagement.editUser.submitting' | cxTranslate) : ('atgUserManagement.editUser.submit' | cxTranslate) }}
          </button>
          <button type="button" class="btn btn-secondary mr-3" (click)="onCancel()">
            {{ 'atgUserManagement.editUser.cancel' | cxTranslate }}
          </button>
        </div>
      </form>
    </div>
  </div>

</div>
